export class HostingPhpConfig {

  public maxExecutionTime: number;
  public memoryLimit: number;
  public postMaxSize: number;
  public uploadMaxFilesize: number;

}

